import { useState, useEffect } from "react";
import { Flex } from "@aws-amplify/ui-react";
import {
  keisokuSettingJson,
  keisokuCycleSettingJson,
  keisokuKanshiSettingJson,
  getKeisokuSettingJson,
  mergeObjects,
  updateKeisokuSettingJson,
  inputNumberLimit,
  signalKanshiSettingJson,
} from '../../../lib/SettingUtil';
import { getFormatNowDate } from '../../../lib/StorageUtil';

import { CheckWrapper } from '../../../componentsWrapper';

import { CustomModal } from "../../CustomModal";
import SpectrumAnalyzerSetting from './SpectrumAnalyzerSetting';
import MeasurementCycleSetting from './MeasurementCycleSetting';
import InterferenceAlertSetting from './InterferenceAlertSetting';
import CalibrationPathMonitoring from './CalibrationPathMonitoring';

const InterferenceMonitoringSettings = ({
  location,
  openChangeModal,
  onCloseChangeModal,
  displaySettingJson,
  downloadCount,
  inputSettingJson,
}) => {
  // 変更後の設定値
  const [editSettingJson, setEditSettingJson] = useState(null);

  const getSettingValueJson = async (locationName) => {
    const settingJson = await getKeisokuSettingJson(locationName);
    console.warn("settingJson", settingJson);
    setEditSettingJson(settingJson);
  }

  // UIコンポーネントの都合上、GUNMAが来るのでSAYADOに変換する関数
  const convertLocationName = (locationName) => {
    return locationName === "GUNMA" ? "SAYADO" : locationName;
  }

  const onClickSaveButton = async () => {
    console.log("onClickSaveButton", editSettingJson);

    onCloseChangeModal();

    let saveSettingValueJson = editSettingJson;

    let totalThresholdDMonitoring = false;

    // total.Threshold D.Targetを設定する
    Object.entries(editSettingJson.total["Threshold D"].Target).map((item, index) => {
      saveSettingValueJson.total["Threshold D"].Target[item[0]] = editSettingJson[item[0]]["Threshold C"].Monitoring;
      totalThresholdDMonitoring = totalThresholdDMonitoring || editSettingJson[item[0]]["Threshold C"].Monitoring;
    })

    // total.Threshold D.Monitoringを設定する
    saveSettingValueJson.total["Threshold D"].Monitoring = totalThresholdDMonitoring && editSettingJson.total["Threshold D"].Monitoring;

    console.log("saveSettingValueJson", saveSettingValueJson);

    // 設定更新
    await updateKeisokuSettingJson(convertLocationName(location), saveSettingValueJson);

    // 設定値を再取得
    getSettingValueJson(convertLocationName(location));
  }

  useEffect(() => {
    const searchLocationName = convertLocationName(location)
    getSettingValueJson(searchLocationName)
  }, [location]);

  useEffect(() => {
    console.warn("editSettingJson", editSettingJson);
  }, [editSettingJson]);

  useEffect(() => {
    if (inputSettingJson !== null && editSettingJson !== null) {
      // マージする
      let mergeSettingJson = mergeObjects(editSettingJson, inputSettingJson);

      // バリデーションチェック
      Object.entries(keisokuSettingJson).map((item, index) => {
        console.log(item[0], item[1]);
        if (item[1].type === "number") {
          // 整数の場合
          mergeSettingJson[item[0]] = inputNumberLimit(mergeSettingJson[item[0]], item[1].input.step, item[1].input)
        }
      });

      Object.entries(keisokuCycleSettingJson).map((item, index) => {
        console.log(item[0], item[1]);
        Object.entries(item[1]).map((itemDetail, index) => {
          for (let key of ["1st", "2nd", "3rd"]) {
            if (!(mergeSettingJson[item[0]][key] != null)) {
              mergeSettingJson[item[0]][key] = null;
            }
            else {
              mergeSettingJson[item[0]][key] = inputNumberLimit(mergeSettingJson[item[0]][key], 1, { min: 1, max: 3 })
            }
          }
        });
      });

      Object.entries(keisokuKanshiSettingJson).map(([slot, slotOption]) => {
        Object.entries(slotOption).map(([threshold, opt]) => {
          mergeSettingJson[slot][threshold].Monitoring = mergeSettingJson[slot][threshold].Monitoring == true ? true : false;

          if (!(mergeSettingJson[slot][threshold].Status_Type == "Error"
            || mergeSettingJson[slot][threshold].Status_Type == "Warning")) {
            mergeSettingJson[slot][threshold].Status_Type = "Info";
          }

          mergeSettingJson[slot][threshold].Value = inputNumberLimit(
            mergeSettingJson[slot][threshold].Value,
            opt.value.input.step, opt.value.range)

          // アラートカウント
          mergeSettingJson[slot][threshold].AlertCount_Enable = mergeSettingJson[slot][threshold].AlertCount_Enable == true ? true : false;
          mergeSettingJson[slot][threshold].Alert_Count = inputNumberLimit(
            mergeSettingJson[slot][threshold].Alert_Count,
            opt.alertCount.input.step, opt.alertCount.range)
        });
      });

      Object.entries(signalKanshiSettingJson).map((supeana) => {
        Object.entries(supeana[1]).map((antena) => {
          Object.entries(antena[1]).map((itemDetail, index) => {
            mergeSettingJson[supeana[0] + "-" + antena[0]][itemDetail[0]].Monitoring = mergeSettingJson[supeana[0] + "-" + antena[0]][itemDetail[0]].Monitoring == true ? true : false;

            if (!(mergeSettingJson[supeana[0] + "-" + antena[0]][itemDetail[0]].Status_Type == "Error"
              || mergeSettingJson[supeana[0] + "-" + antena[0]][itemDetail[0]].Status_Type == "Warning")) {
              mergeSettingJson[supeana[0] + "-" + antena[0]][itemDetail[0]].Status_Type = "Info";
            }

            mergeSettingJson[supeana[0] + "-" + antena[0]][itemDetail[0]].Value = inputNumberLimit(
              mergeSettingJson[supeana[0] + "-" + antena[0]][itemDetail[0]].Value,
              itemDetail[1].option1.input.step, itemDetail[1].option1.range)
          });
        });
      });

      // マージした設定値をセットする
      setEditSettingJson((prev) => {
        return {
          ...mergeSettingJson
        }
      });
    }

  }, [inputSettingJson]);

  // ダウンロードボタンイベント
  useEffect(() => {
    console.log(downloadCount);

    if (downloadCount > 0) {
      // jsonファイルをダウンロードする
      const json = JSON.stringify(editSettingJson, null, '  ');

      const blob = new Blob([json], { type: "application/json" });

      const a = document.createElement("a");

      a.href = URL.createObjectURL(blob);

      a.download = "interference-monitoring-電波干渉監視設定-" + displaySettingJson.location_name[convertLocationName(location)] + "-" + getFormatNowDate() + ".json";

      a.click();
    }
  }, [downloadCount]);
  return (
    <>
      <Flex
        gap="40px"
        direction="column"
        backgroundColor="rgba(255,255,255,1)"
        height='calc(100vh - 340px)'
        width="100%"
        overflow="auto"
        padding="0px 40px 0px 40px"
      >
        {/* 電波計測設定 */}
        <SpectrumAnalyzerSetting
          editSettingJson={editSettingJson}
          setEditSettingJson={setEditSettingJson}
        />

        {/* スペアナ計測サイクル設定 */}
        <MeasurementCycleSetting
          editSettingJson={editSettingJson}
          setEditSettingJson={setEditSettingJson}
        />

        {/* 干渉波アラーム監視設定 */}
        <InterferenceAlertSetting
          editSettingJson={editSettingJson}
          setEditSettingJson={setEditSettingJson}
        />

        {/* 校正経路監視 */}
        <CalibrationPathMonitoring
          editSettingJson={editSettingJson}
          setEditSettingJson={setEditSettingJson}
        />
      </Flex>

      {/* 設定変更確認モーダル */}
      <CustomModal
        open={openChangeModal}
        onClose={onCloseChangeModal}
      >
        <CheckWrapper
          msg={displaySettingJson.location_name[convertLocationName(location)] + "の電波干渉監視設定を変更します。よろしいですか？"}
          onClickOk={onClickSaveButton}
          onClickCancel={onCloseChangeModal}
        />
      </CustomModal>
    </>
  );
};

export default InterferenceMonitoringSettings;